import * as vuelidateValidators from '@vuelidate/validators';

export const postcodeValidator = vuelidateValidators.helpers.regex(/^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z])))) {0,1}[0-9][A-Za-z]{2})$/i);
export const phoneValidator = vuelidateValidators.helpers.regex(/^(((\+44\s?\d{4}|\(?0\d{4}\)?)\s?\d{3}\s?\d{3})|((\+44\s?\d{3}|\(?0\d{3}\)?)\s?\d{3}\s?\d{4})|((\+44\s?\d{2}|\(?0\d{2}\)?)\s?\d{4}\s?\d{4}))(\s?\#(\d{4}|\d{3}))?$/);
export const mobileValidator = vuelidateValidators.helpers.regex(/^07\d{9}$/)
export const NationalInsuranceNumberValidator = vuelidateValidators.helpers.regex(/^(?!BG)(?!GB)(?!NK)(?!KN)(?!TN)(?!NT)(?!ZZ)(?:[A-CEGHJ-PR-TW-Z][A-CEGHJ-NPR-TW-Z])(?:\s*\d\s*){6}([A-D]|\s)$/i);
export const ExceedingMaxCharLength = (max) => (value) => {
	if (value.length > max) {
		return false;
	}
	return true; // It doesnt exceed, we are allowed to pass validation
};